export default __webpack_public_path__ + "static/media/github.f1da7912.webp";